
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Playground, Props } from 'docz'
import NavigationControl from './navigation-control.js'


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "navigationcontrol"
    }}>{`NavigationControl`}</h1>
    <hr />
    <h2 {...{
      "id": "navigation-control"
    }}>{`Navigation control`}</h2>
    <Playground __position={1} __code={'<NavigationControl title=\"Navigation Control title\">\n  Content\n</NavigationControl>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      NavigationControl
    }} style={{
      backgroundColor: "#333",
      margin: '-2em',
      padding: '2em'
    }} mdxType="Playground">
  <NavigationControl title="Navigation Control title" mdxType="NavigationControl">Content</NavigationControl>
    </Playground>
    <hr />
    <h2 {...{
      "id": "properties"
    }}>{`Properties`}</h2>
    <Props of={NavigationControl} mdxType="Props" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;